import React from "react";
import { Select } from "../../../../../ui/components/Select";
import { FieldFootnote } from "./FieldFootnote";
import { FieldRowProps } from "./fieldTypes";

/**
 * A dropdown. Choices come from the API's `options` map, so the vocabulary the
 * server validates against is the only one the user can pick from.
 */
export const SelectFieldRow: React.FC<FieldRowProps> = ({
  config,
  value,
  locked,
  lockReason,
  errorMessage,
  options,
  onChange,
}) => (
  <div className="flex w-full flex-col gap-1">
    <Select
      className="w-full"
      label={config.label}
      placeholder="Select one"
      value={value === "" ? undefined : value}
      disabled={locked}
      error={Boolean(errorMessage)}
      onValueChange={onChange}
    >
      {options.map((option) => (
        <Select.Item key={option.value} value={option.value}>
          {option.label}
        </Select.Item>
      ))}
    </Select>

    <FieldFootnote
      hint={config.hint}
      example={config.example}
      lockReason={lockReason}
      errorMessage={errorMessage}
    />
  </div>
);
